// ── Les questions proposees par l'onglet Assistant quand il est vide (A3, chantier ASI) ──
// Dans l'editeur, elles suivent l'outil actif ; un outil sans questions a lui prend celles de l'editeur ; hors de
// l'editeur, ce sont des questions generales.
import type { ToolType } from '@/lib/types';

export interface Suggestions {
  /** Le titre au-dessus des questions */
  label: string;
  questions: [string, string, string];
}

const GENERAL: Suggestions = {
  label: 'Questions fréquentes',
  questions: ['Comment créer un projet ?', 'Comment partager un projet avec quelqu\'un ?', 'Comment faire une copie de mon projet ?'],
};

const EDITOR: Suggestions = {
  label: 'Dans l\'éditeur',
  questions: ['Fais une pièce de 3 × 4 m', 'Comment voir ma maison en 3D ?', 'Comment faire un étage ?'],
};

const BY_TOOL: Partial<Record<ToolType, Suggestions>> = {
  wall: { label: 'Avec l\'outil Mur', questions: ['Fais un mur de 4 m', 'Comment fermer une pièce ?', 'Comment supprimer un mur ?'] },
  rectangle: { label: 'Avec l\'outil Rectangle', questions: ['Comment dessiner une pièce rectangulaire rapidement ?', 'Comment couper une pièce en deux ?', 'Comment changer l\'épaisseur des murs ?'] },
  door: { label: 'Avec l\'outil Porte', questions: ['Comment ajouter une porte-fenêtre dans un mur ?', 'Comment changer le sens d\'ouverture d\'une porte ?', 'Comment placer une porte à une distance exacte ?'] },
  window: { label: 'Avec l\'outil Fenêtre', questions: ['Comment régler la hauteur d\'une fenêtre ?', 'Comment ajouter une baie vitrée ?', 'Comment placer une fenêtre à une distance exacte ?'] },
  roof: { label: 'Avec l\'outil Toiture', questions: ['Comment changer la pente du toit ?', 'Comment faire un toit à quatre pans ?', 'Comment voir le toit en 3D ?'] },
  staircase: { label: 'Avec l\'outil Escalier', questions: ['Je veux mettre un escalier entre le rez-de-chaussée et l\'étage', 'Comment faire une trémie ?', 'Comment tourner un escalier ?'] },
  symbol: { label: 'Avec les symboles électriques', questions: ['Comment placer des prises électriques ?', 'Comment regrouper les prises sur un même circuit ?', 'Comment tirer les câbles ?'] },
  wire: { label: 'Avec l\'outil Câble', questions: ['Comment tirer les câbles ?', 'Comment regrouper les prises sur un même circuit ?', 'Comment supprimer un câble ?'] },
  furniture: { label: 'Avec le mobilier', questions: ['Comment ajouter un canapé dans le salon ?', 'Comment tourner un meuble ?', 'Comment voir les meubles en 3D ?'] },
  terrace: { label: 'Avec l\'outil Terrasse', questions: ['Comment ajouter une terrasse en bois ?', 'Comment changer le revêtement de la terrasse ?', 'Comment voir la terrasse en 3D ?'] },
  calibrate: { label: 'Avec la calibration', questions: ['Comment mettre à l\'échelle un plan scanné ?', 'Mon plan est penché, comment le remettre droit ?', 'Comment mesurer une distance ?'] },
  align: { label: 'Avec l\'outil Aligner', questions: ['Mon plan est penché, comment le remettre droit ?', 'Comment aligner deux murs ?', 'Comment mettre à l\'échelle un plan scanné ?'] },
  separator: { label: 'Avec l\'outil Séparation', questions: ['Comment couper une pièce en deux ?', 'Comment renommer une pièce ?', 'Comment voir la surface d\'une pièce ?'] },
};

/** L'outil actif de l'editeur, ou undefined hors de l'editeur */
export function suggestionsFor(tool: string | undefined): Suggestions {
  if (tool === undefined) return GENERAL;
  return BY_TOOL[tool as ToolType] ?? EDITOR;
}
